import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { CreateFirewallVMRuleRequest } from '../../@types/firewall-vm-rule';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    id: number;
    body: CreateFirewallVMRuleRequest;
}

export function useCreateFirewallRuleMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, body }: Vars) => Endpoints.v1.Firewalls.VMRules.createRule(id, body),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.vm-rules', variables.id],
            });
            notifications.show({
                title: t('firewall.ruleAddedTitle'),
                message: t('firewall.ruleAddedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('firewall.ruleAddFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
